module.exports = __webpack_public_path__ + "img/icon_kehu_14.c649474c.png";